import { EP } from "../configs/constant";
import { getPath } from "../helpers/handleUrl";
import { IComboResponse } from "../types/combo";
import axiosThirdService, { AxiosThirdService } from "./axiosThirdService";
class ComboService {
    readonly service: AxiosThirdService;
    constructor() {
        this.service = axiosThirdService;
    }
    getCombos() {
        return this.service.get<IComboResponse>(getPath(EP.API, EP.V1, EP.COMBO, EP.LIST))
    }
}
const comboService = new ComboService();
export default comboService;